/** Measure only the front view and its labels, independent of the current dock width. */
export function measureButtonEditorWidth(view: HTMLElement, shell: HTMLElement): number {
  const copy = view.cloneNode(true) as HTMLElement;
  copy.querySelectorAll("[id]").forEach(element => element.removeAttribute("id"));
  copy.style.cssText = "position:absolute;visibility:hidden;pointer-events:none;width:max-content;max-width:none;left:0;top:0";
  const horizontal = view.classList.contains("C1_horizontal");
  const first = copy.querySelector<HTMLElement>(".C1_first");
  const second = copy.querySelector<HTMLElement>(".C1_second");
  const hasSideLabels = !!(first || second);
  if (horizontal) copy.style.gridTemplateColumns = hasSideLabels ? "max-content max-content max-content" : "max-content";
  const measurementParent = view.closest?.(".C1_buttonEditorViewport")?.parentElement ?? view.parentElement;
  measurementParent!.appendChild(copy);
  let width: number;
  try {
    width = copy.getBoundingClientRect().width;
    if (horizontal && hasSideLabels) {
      const firstWidth = first?.getBoundingClientRect().width ?? 0;
      const secondWidth = second?.getBoundingClientRect().width ?? 0;
      // The real layout reserves equal space on either side of the centered button.
      width += Math.abs(firstWidth - secondWidth);
    }
  } finally {
    copy.remove();
  }
  // Include only the surrounding padding and borders, never sibling content.
  for (let element = view.parentElement; element; element = element.parentElement) {
    const style = getComputedStyle(element);
    for (const key of ["paddingLeft", "paddingRight", "borderLeftWidth", "borderRightWidth"] as const) {
      width += parseFloat(style[key]) || 0;
    }
    if (element === shell) break;
  }
  return Math.ceil(width);
}
